import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
const { clinicId } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{list:MasterTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllDisease}`,{...params,clinicId});
    return result.data;
}


export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.diseaseSave}`,params);
    return result.data;
}

export const deleteMasterData = async (id:number):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.delete(`${MastersApi.deleteDisease}${clinicId}?id=${id}`);
    return result.data;
}

